import React, { Component } from "react"

import { inIssueFilter } from "shared/search/containers/Filter/FilterCreators"

import { genericBarPieScene } from "search-new/containers/Visualization/VisualizationScene/VisualizationScenes"

import { internationalRegions } from "shared/imports/regionConstants"

import { PublicOrganizationTypeInternationalFilter } from "shared/search/containers/Filter/PublicOrganizationFilters"

/* *****************************************************************
 * MAPS
 ******************************************************************* */

/* *****************************************************************
 * BAR / PIE COMBO GRAPHS
 ******************************************************************* */
export const PublicOrganizationInIssuesBarPieScene = (props) => genericBarPieScene(props)
PublicOrganizationInIssuesBarPieScene.defaultProps = {
    uniqueVizSceneId: "publicOrganizationInIssuesBarPieScene",
    filterId: inIssueFilter.defaultProps.uniqueFilterId,
    variableRequestKey: "inIssueFrequency",
    label: "Issues",
    icon: DjangIO.app.models.QuorumDataType.issue_management.icon,
    sidebarTableLabel: "Organization tagged to Issue",
}

export const PublicOrganizationInternationalBarPieScene = (props) => genericBarPieScene(props)
PublicOrganizationInternationalBarPieScene.defaultProps = {
    uniqueVizSceneId: "publicOrganizationTypeBarPieScene",
    filterId: PublicOrganizationTypeInternationalFilter.defaultProps.uniqueFilterId,
    variableRequestKey: "typeFrequency",
    label: "Organization Types",
    icon: DjangIO.app.models.QuorumDataType.organization.icon,
    sidebarTableLabel: "Organizations by Type",
    regions: internationalRegions,
}

/* *****************************************************************
 * LINE GRAPH (TREND)
 ******************************************************************* */
